import React, { useEffect, useRef, useState, useCallback } from 'react';

function AutoLogoutWrapper({ children }) {
  const timer = useRef(null);
  const warningTimer = useRef(null);
  const [showWarning, setShowWarning] = useState(false);

  const logout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const startTimers = useCallback(() => {
    clearTimeout(timer.current);
    clearTimeout(warningTimer.current);
    setShowWarning(false);

    // Tiempo total de inactividad permitido: 8 horas (480 minutos)
    const totalTimeMs = 480 * 60 * 1000;

    // Mostrar advertencia 30 segundos antes de cerrar sesión
    warningTimer.current = setTimeout(() => {
      setShowWarning(true);
    }, totalTimeMs - 30000); // 30 segundos antes del logout

    // Cerrar sesión tras 8 horas
    timer.current = setTimeout(logout, totalTimeMs);
  }, []);

  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      // Si el usuario cambia de pestaña o minimiza, seguir con el temporizador normal
      timer.current = setTimeout(logout, 480 * 60 * 1000);
    } else {
      startTimers();
    }
  }, [startTimers]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(event => window.addEventListener(event, startTimers));
    document.addEventListener('visibilitychange', handleVisibilityChange);

    startTimers();

    return () => {
      events.forEach(event => window.removeEventListener(event, startTimers));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(timer.current);
      clearTimeout(warningTimer.current);
    };
  }, [startTimers, handleVisibilityChange]);

  return (
    <>
      {showWarning && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#ffcc00',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
          zIndex: 9999
        }}>
          ⚠️ Tu sesión se cerrará en 30 segundos por inactividad
        </div>
      )}
      {children}
    </>
  );
}

export default AutoLogoutWrapper;
